import NavItem from "./NavItem";

export default function NavBar({
  menu,
  logo,
  logoText,
  background,
  colorHover,
  theme,
  setIsShowPopUp,
  backgroundActive,
  backgroundHover,
  backgroundBorder,
  classLogo,
}) {
  return (
    <nav
      className={`h-[9vh] max-w-screen w-screen fixed z-[54] bottom-0 left-0 bg-cover bg-center ${background}`}
    >
      {/* <img className="w-full absolute top-0 left-0 object-contain" alt="" src={bgNav} /> */}
      <div className={`w-full h-[2px] ${backgroundBorder}`}></div>
        <div className="flex h-full text-white">
        <div
          className="flex-1 flex justify-center items-center cursor-pointer"
          onClick={() => setIsShowPopUp(true)}
        >
          {logo ? (
            <img className={`${classLogo ? classLogo : "w-14 md:w-20"} max-h-[8vh] object-contain p-1`} alt="Logo" src={logo} />
          ) : (
            <div className="logoText font-semibold bg-clip-text text-transparent bg-gradientMain uppercase text-[10px] md:text-[16px] lg:text-[28px]">
              {logoText}
            </div>
          )}
        </div>
        {menu.map((item, index) => (
          <NavItem
            key={index}
            path={item.path}
            label={item.label}
            icon={item.icon}
            iconHover={item.iconHover}
            matchSubRoutes={item.matchSubRoutes}
            theme={theme}
            colorHover={colorHover}
            backgroundActive={backgroundActive}
            backgroundHover={backgroundHover}
          />
        ))}
      </div>
    </nav>
  );
}
